<template>
	<div class="answer-box options-box panel gray-small-square-1" :class="{ 'lg': large }">

		<div class="shadow left"></div>
		<div class="shadow top"></div>
		<div class="shadow right"></div>
		<div class="shadow bottom"></div>

		<div class="body">
			<div class="opcoes listagem">
				<div v-for="(opcao, index) in opcoes" class="opcao" :class="{ 'correta': opcao.Correta }">
					<strong>{{ opcao.Referencia }}</strong> {{ opcao.Texto }}
				</div>
			</div>
			<div class="buttons">
				
				<button @click="previous" class="btn btn-gray previous left">Previous</button>
				<next :locked="false" :click="next" :is-last-page="!hasNext()" :part="part"></next>
			</div>
		</div>
	</div>
</template>

<script>
	import bus from '@/bus/event-bus.js'
	import next from '../ui/NextButton'
	
	export default {
		props: ['part', 'large'],

		data() {
			return {
				partId: null,
				pergunta: null,
				currentNumber: 1
			}
		},

		computed: {
			opcoes() {
				return this.part.Opcoes
			}
		},

		mounted() {
		},

		methods: {

			next() {
				bus.$emit('next.part');
			},

			previous() {
				bus.$emit('previous.part');
			},

			hasNext() {
				return false
			},

			hasPrevious() {
				return false;
			}

			
		},
		components: {
			'next': next
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/perguntas/OptionsBox.vue